import React, { useEffect, useState } from "react";

// Native-feeling splash shown for a beat when a visitor enters the sandbox, so
// it feels like the real app is booting up before the walkthrough appears.
export function SandboxSplash({ onDone, duration = 1500 }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), duration - 300);
    const t2 = setTimeout(() => onDone?.(), duration);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [duration, onDone]);

  return (
    <div
      data-testid="sandbox-splash"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0B111E] transition-opacity duration-300 ${leaving ? "opacity-0" : "opacity-100"}`}
    >
      <div className="flex flex-col items-center" style={{ animation: "sp-splash-pop 600ms cubic-bezier(0.2,0.8,0.2,1) both" }}>
        <img src="/logo-mark.webp" alt="Send-Proof" className="h-24 w-24 rounded-[1.4rem] shadow-2xl shadow-emerald-500/20 ring-1 ring-white/10" />
        <span className="mt-5 font-heading text-2xl font-extrabold tracking-tight text-white">Send-Proof</span>
        <span className="mt-1 text-sm text-white/50">Proof it got done.</span>
      </div>
      <div className="absolute bottom-16 h-1 w-28 overflow-hidden rounded-full bg-white/10">
        <div className="h-full w-full rounded-full bg-emerald-500" style={{ animation: "sp-splash-bar 1400ms ease-out both" }} />
      </div>
      <style>{`
        @keyframes sp-splash-pop { from { opacity: 0; transform: scale(0.88); } to { opacity: 1; transform: scale(1); } }
        @keyframes sp-splash-bar { from { transform: translateX(-100%); } to { transform: translateX(0); } }
      `}</style>
    </div>
  );
}
